import {Button, Descriptions, Form, Input, Modal, Popconfirm, Select, Table, Tag} from 'antd';
import {ColumnsType, TablePaginationConfig} from 'antd/lib/table';
import {DeleteOutlined, UserAddOutlined, InfoCircleOutlined, EditOutlined} from '@ant-design/icons';
import {
  rolesList,
  updateRole,
  roleEmplyoees,
  addInRole,
  removeFromRole,
  pageSizeChange,
  pageNumberChange,
  searchBy,
  sortBy,
} from './rolesSlice';
import {useEffect, useState} from 'react';
import type {GRP_EMP_DATA, PERMISSION_GROUP, ADD_USER, UPDATE_GROUP_PAYLOAD} from './roles.type';
import {useAppDispatch, useAppSelector} from '../../../../common/hooks';
import {clearEmployeesFilters, employeesList} from '../employees/employeeSlice';
import {formatDate} from '../../../../utils/formatDate';
import {debounce} from 'lodash';
import {debounceDelay, sortbyFilter} from '../../../../common/constants';
const {Option} = Select;

const EmployeeList = ({group}: {group: PERMISSION_GROUP}) => {
  const dispatch = useAppDispatch();
  const roles = useAppSelector((state) => state.roles);
  const employeeOptions = useAppSelector((state) => state.employees);
  const userPermission = useAppSelector((state) => state.config.config.permissions);
  const [editRoleModelOpen, setEditRoleModelOpen] = useState(false);
  const [infoRoleModelOpen, setInfoRoleModelOpen] = useState(false);
  const [addEmployeeModelOpen, setAddEmployeeModelOpen] = useState(false);
  const [editRoleForm] = Form.useForm();
  const [addUserForm] = Form.useForm();
  // const [value, setValue] = useState('');
  const columns: ColumnsType<GRP_EMP_DATA> = [
    {
      title: 'S. No.',
      width: 70,
      render: (test, record, index) => {
        return (
          <>
            {(roles.roleEmployeesList.page_number - 1) * roles.roleEmployeesList.page_size +
              index +
              1}
          </>
        );
      },
    },
    {
      title: 'Full Name',
      dataIndex: 'name',
      sorter: true,
    },
    {
      title: 'User Name',
      dataIndex: 'username',
      sorter: true,
    },
    {
      title: ' Email',
      dataIndex: 'email',
      sorter: true,
    },

    {
      title: 'Actions',
      key: 'operation',
      render: (_, record) => {
        return (
          <>
            {userPermission.update_permissiongroup && (
              <Popconfirm
                title='Are you sure '
                onConfirm={() => {
                  dispatch(removeFromRole(record.relation_id)).then(() => {
                    dispatch(
                      roleEmplyoees({
                        groupId: group.id,
                        filters: {
                          page_size: roles.roleEmployeesList.page_size,
                          page_number: roles.roleEmployeesList.page_number,
                          sort_by: roles.roleEmployeesList.sort_by,
                          ascending: roles.roleEmployeesList.ascending,
                          search: roles.roleEmployeesList.search,
                        },
                      }),
                    );
                  });
                }}
                okText='Yes'
                cancelText='No'
              >
                <DeleteOutlined
                  style={{cursor: 'pointer', fontSize: '16px', color: 'red', marginLeft: '10px'}}
                />
              </Popconfirm>
            )}
          </>
        );
      },
    },
  ];
  !userPermission.update_permissiongroup ? (columns.length = 3) : null;

  useEffect(() => {
    dispatch(
      roleEmplyoees({
        groupId: group.id,
        filters: {
          page_size: roles.roleEmployeesList.page_size,
          page_number: roles.roleEmployeesList.page_number,
          sort_by: roles.roleEmployeesList.sort_by,
          ascending: roles.roleEmployeesList.ascending,
          search: roles.roleEmployeesList.search,
        },
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    roles.roleEmployeesList.page_number,
    roles.roleEmployeesList.page_size,
    roles.roleEmployeesList.search,
    roles.roleEmployeesList.sort_by,
    roles.roleEmployeesList.ascending,
  ]);

  const handleEmployeeBouncing = debounce((newValue) => {
    dispatch(employeesList({search: newValue, is_active: true}));
  }, debounceDelay);

  const handleFilterSearch = (e: string) => {
    if (e.length > 3) {
      dispatch(searchBy(e));
    } else if (e.length === 0) {
      dispatch(searchBy(e));
    }
  };

  const handleEditGroup = (values: UPDATE_GROUP_PAYLOAD) => {
    group.name === values.name ? delete values.name : null;
    dispatch(updateRole({groupId: group.id, payload: values}))
      .unwrap()
      .then(() => {
        setEditRoleModelOpen(false);
        dispatch(rolesList());
      });
  };
  const handleAddEmployeeModalClose = () => {
    setAddEmployeeModelOpen(false);
    dispatch(clearEmployeesFilters());
    addUserForm.resetFields();
  };
  const handleAddUser = (value: {user_id: string}) => {
    const payload: ADD_USER = {group_id: group.id, employee_id: parseInt(value.user_id)};
    dispatch(addInRole(payload))
      .unwrap()
      .then(() => {
        handleAddEmployeeModalClose();
        dispatch(
          roleEmplyoees({
            groupId: group.id,
            filters: {
              page_size: 10,
              page_number: 1,
              sort_by: '',
              ascending: true,
              search: '',
            },
          }),
        );
      });
  };

  return (
    <>
      <div>
        <div
          style={{
            margin: '10px 0px 10px 0px',
            width: '100%',
            display: 'grid',
            gridTemplateColumns: '350px 1fr',
          }}
        >
          <Input.Search
            placeholder='Search'
            defaultValue={roles.roleEmployeesList.search}
            style={{borderRadius: '10px'}}
            allowClear
            onSearch={(e) => handleFilterSearch(e)}
          />
          {userPermission.update_permissiongroup && (
            <div style={{width: '100%', textAlign: 'end'}}>
              <Button
                type='primary'
                style={{borderRadius: '5px', marginInline: '5px'}}
                icon={<InfoCircleOutlined />}
                onClick={() => {
                  // editRoleForm.setFieldsValue({name: group.name, permissions: group.permissions});
                  setInfoRoleModelOpen(true);
                }}
              >
                Role Info
              </Button>
              <Button
                type='primary'
                style={{borderRadius: '5px', marginInline: '5px'}}
                icon={<EditOutlined />}
                onClick={() => {
                  editRoleForm.setFieldsValue({name: group.name, permissions: group.permissions});
                  setEditRoleModelOpen(true);
                }}
              >
                Edit Role
              </Button>
              <Button
                type='primary'
                style={{borderRadius: '5px', marginInline: '5px'}}
                icon={<UserAddOutlined />}
                onClick={() => {
                  setAddEmployeeModelOpen(true);
                  dispatch(employeesList({is_active: true}));
                }}
              >
                Add User
              </Button>
            </div>
          )}
        </div>
        <Table
          rowKey='relation_id'
          columns={columns}
          pagination={
            {
              total: roles.roleEmployeesList.totalDataCount,
              current: roles.roleEmployeesList.page_number,
              pageSize: roles.roleEmployeesList.page_size,
              showSizeChanger: true,
              // onChange: (pageNumber, pageSize: number) => {
              //   if (pageSize !== roles.roleEmployeesList.page_size) {
              //     dispatch(pageSizeChange({pageNumber, pageSize}));
              //   }
              //   dispatch(pageNumberChange(pageNumber));
              // },
            } as TablePaginationConfig
          }
          loading={roles.isLoading}
          size='middle'
          dataSource={roles.roleEmployeesList.pageData}
          scroll={{x: undefined, y: '60vh'}}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          onChange={(pagination, _, {order, field}: any) => {
            if (pagination.pageSize && pagination.pageSize !== roles.roleEmployeesList.page_size) {
              dispatch(pageSizeChange(pagination.pageSize));
            }
            if (pagination.current && pagination.current !== roles.roleEmployeesList.page_number) {
              dispatch(pageNumberChange(pagination.current));
            }
            if (field) {
              if (order === sortbyFilter.DESCEND) {
                dispatch(sortBy({ascending: false, sortBy: field}));
              } else {
                dispatch(sortBy({ascending: true, sortBy: field}));
              }
            }
          }}
        />
      </div>
      <Modal
        title={group.name}
        open={infoRoleModelOpen}
        width={800}
        onCancel={() => {
          setInfoRoleModelOpen(false);
        }}
        footer={null}
        maskClosable={false}
      >
        <Descriptions bordered column={2}>
          <Descriptions.Item label='Role Name' labelStyle={{fontWeight: 'bolder'}}>
            {group.name}
          </Descriptions.Item>
          <Descriptions.Item label='Status' labelStyle={{fontWeight: 'bolder'}}>
            {group.is_active ? <Tag color='green'>Active</Tag> : <Tag color='red'>Inactive</Tag>}
          </Descriptions.Item>
          <Descriptions.Item label='Created By' labelStyle={{fontWeight: 'bolder'}}>
            {group.created_by}
          </Descriptions.Item>
          <Descriptions.Item label='Created At' labelStyle={{fontWeight: 'bolder'}}>
            {formatDate(group.created_at)}
          </Descriptions.Item>
          <Descriptions.Item label='Updated By' labelStyle={{fontWeight: 'bolder'}}>
            {group.updated_by}
          </Descriptions.Item>
          <Descriptions.Item label='Updated At' labelStyle={{fontWeight: 'bolder'}}>
            {formatDate(group.updated_at)}
          </Descriptions.Item>
          <Descriptions.Item label='Permissions ' span={2} labelStyle={{fontWeight: 'bolder'}}>
            {group.permissions.map((x) => {
              return (
                <>
                  {x},
                  <br />
                </>
              );
            })}
          </Descriptions.Item>
        </Descriptions>
      </Modal>
      <Modal
        title='Edit Role '
        open={editRoleModelOpen}
        onCancel={() => {
          setEditRoleModelOpen(false);
        }}
        okText={'Edit'}
        maskClosable={false}
        onOk={() => {
          editRoleForm
            .validateFields()
            .then((values) => {
              handleEditGroup(values);
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <Form
          form={editRoleForm}
          name='Edit Role'
          labelCol={{span: 5}}
          wrapperCol={{span: 19}}
          layout='horizontal'
        >
          <Form.Item
            label='Name'
            name='name'
            rules={[
              {required: true, message: 'Please enter a name'},
              {min: 4, message: 'Atleast 4 characters are required'},
            ]}
          >
            <Input autoComplete='off' placeholder='Role Name' />
          </Form.Item>
          <Form.Item
            label='Permissions'
            name='permissions'
            rules={[{required: true, message: 'At least one pemission is required'}]}
          >
            <Select
              mode='multiple'
              allowClear
              style={{width: '100%'}}
              placeholder='Please select'
              listHeight={200}
            >
              {roles.totalPermissions.map((x, i) => (
                <Option key={i} value={x}>
                  {x}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title='Assign Role to Employee'
        open={addEmployeeModelOpen}
        onCancel={() => {
          handleAddEmployeeModalClose();
        }}
        maskClosable={false}
        okText={'Add User'}
        onOk={() => {
          addUserForm
            .validateFields()
            .then((values) => {
              handleAddUser(values);
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
        confirmLoading={roles.isLoading}
      >
        <Form form={addUserForm} name='Add User' layout='vertical'>
          <Form.Item
            label='Select a User'
            name='user_id'
            rules={[{required: true, message: 'At least one pemission is required'}]}
            extra='Enter min 4 char to search username'
          >
            {/* <AutoComplete style={{width: 200}} onSearch={handleSearch} placeholder='input here'> */}
            <Select
              showSearch
              // value={value}
              placeholder='Search User'
              style={{width: '80%'}}
              defaultActiveFirstOption={false}
              showArrow={false}
              filterOption={false}
              onSearch={(e) => {
                if (e.length > 3) handleEmployeeBouncing(e);
              }}
              // onChange={handleChange}
              notFoundContent={null}
              loading={roles.isLoading}
            >
              {employeeOptions.employees.pageData.map((x) => (
                <Option key={x.id}>{x.username}</Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default EmployeeList;
